const o=(o,t)=>t&&`${t}-${o}`;export{o as getDataTestId};
